import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UserInfoModel } from 'flux-user';

@Component({
    selector: 'user-list-item',
    templateUrl: './user-list-item.cmp.html',
    styleUrls: [ './user-list-item.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
/**
 * This component is used to encapsulate functionality such as
 * displaying and removing a collaborator from the collaborator
 * list in the project / diagram share window. A collabortator
 * can be added by using the <collaborator-item></collaborator-item>
 * selector.
 */
export class UserListItem {

    /**
     * Input collaborator from the diagram collabs array
     */
    @Input()
    public user: UserInfoModel;

    @Output()
    public itemSelected: EventEmitter<UserInfoModel>;

    constructor() {
        this.itemSelected = new EventEmitter();
    }

    public onClickEvent() {
        this.itemSelected.emit( this.user );
    }
}
